import React, { memo } from 'react';
import { ProductCard, Product } from './ProductCard';
const popularItems: Product[] = [{
  id: '1',
  title: 'Jeremiah Smith #4 Signed Ohio State Full-Size Helmet',
  tagline: 'Riddell Speed Authentic',
  type: 'memorabilia',
  image: 'https://cdn.magicpatterns.com/uploads/9hBEeTERgbU2Gcm7Vypzwq/IMG_0079.jpg',
  badge: 'Autographed'
}, {
  id: '2',
  title: 'Cooper Flagg Bowman Chrome RC',
  tagline: 'Bowman Chrome Rookie',
  type: 'card',
  image: 'https://cdn.magicpatterns.com/uploads/6KkUBU87YRibpVnWia2kdp/IMG_0076.jpg',
  badge: 'Graded'
}, {
  id: '3',
  title: 'Jaxon Smith-Njigba 2023 Donruss Downtown PSA 10',
  tagline: 'Donruss Downtown',
  type: 'card',
  image: 'https://cdn.magicpatterns.com/uploads/rWatCmjWdytf5HQGub38sH/IMG_0084.jpg',
  badge: 'Graded'
}, {
  id: '4',
  title: 'Shohei Ohtani 2025 Topps Chrome 1990',
  tagline: 'Topps Chrome',
  type: 'card',
  image: 'https://cdn.magicpatterns.com/uploads/fEnAJ69zHxfbSz9ks1gxCV/IMG_0077.jpg',
  badge: 'Graded'
}, {
  id: '5',
  title: 'Signed Ohio State Mini Helmet',
  tagline: 'Riddell Speed Mini',
  type: 'memorabilia',
  image: 'https://cdn.magicpatterns.com/uploads/x3Acn6dBnXgT5atkGSYwaf/IMG_0101.jpg',
  badge: 'Autographed'
}, {
  id: '6',
  title: '1958 Topps Mickey Mantle PSA 1',
  tagline: 'Vintage Topps',
  type: 'card',
  image: 'https://cdn.magicpatterns.com/uploads/3bmX1MJcmT5hep3B2FZyTq/IMG_0073.jpg',
  badge: 'Graded'
}, {
  id: '7',
  title: 'Travis Hunter 2024 Donruss Downtown RC',
  tagline: 'Donruss Downtown',
  type: 'card',
  image: 'https://cdn.magicpatterns.com/uploads/nQ6ifiNBEDaZzEFCFSM6xb/IMG_0074.jpg',
  badge: 'Graded'
}, {
  id: '8',
  title: 'Signed Las Vegas Raiders Mini Helmet',
  tagline: 'Riddell Speed Mini',
  type: 'memorabilia',
  image: 'https://cdn.magicpatterns.com/uploads/pGu6jpD4vc3TD4TQqA9843/IMG_0092.jpg',
  badge: 'Autographed'
}];
export const FeaturedProducts = () => {
  return <section className="py-16 md:py-24 bg-white" data-id="element-17">
      <div className="container mx-auto px-4" data-id="element-18">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4" data-id="element-19">
          <div data-id="element-20">
            <h2 className="font-heading text-3xl md:text-4xl text-ink uppercase tracking-wide" data-id="element-21">
              Popular Items
            </h2>
            <p className="text-silver mt-2 max-w-xl" data-id="element-22">
              A look at the kind of cards and memorabilia we carry. These are
              representative highlights, not live in-stock listings.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-23">
          {popularItems.map(product => <ProductCard key={product.id} product={product} data-id="element-24" />)}
        </div>
      </div>
    </section>;
};